(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-extras"] && !Shopify.designMode) return;
  try {
    (function() {
    var TIMER_KEY = 'cart_urgency_end';
    var DURATION = 15 * 60 * 1000;

    function getEndTime() {
      var end = sessionStorage.getItem(TIMER_KEY);
      if (!end || parseInt(end, 10) <= Date.now()) {
        end = Date.now() + DURATION;
        sessionStorage.setItem(TIMER_KEY, end);
      }
      return parseInt(end, 10);
    }

    function tick() {
      var el = document.getElementById('cx-countdown');
      var container = document.getElementById('cx-timer');
      if (!el || !container) return;

      var end = getEndTime();
      var diff = Math.max(0, end - Date.now());
      var mins = Math.floor(diff / 60000);
      var secs = Math.floor((diff % 60000) / 1000);

      el.textContent = String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');

      if (diff <= 0) {
        container.classList.add('cx-timer--expired');
        return;
      }

      if (mins < 5) {
        container.classList.add('cx-timer--urgent');
      }

      requestAnimationFrame(function() { setTimeout(tick, 1000); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tick);
    } else {
      tick();
    }

    var observer = new MutationObserver(function() {
      var el = document.getElementById('cx-countdown');
      if (el && !el.dataset.ticking) {
        el.dataset.ticking = 'true';
        tick();
      }
    });

    var target = document.querySelector('.cart-drawer__dialog') || document.body;
    observer.observe(target, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cyber-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cyber-countdown')) {
    class CyberCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end || '');
        if (Number.isNaN(this.end)) return;
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = window.setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      set(unit, value) {
        const el = this.querySelector(`[data-unit="${unit}"]`);
        if (el) el.textContent = String(value).padStart(2, '0');
      }

      tick() {
        const diff = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        const days = Math.floor(diff / 86400);
        this.set('d', days);
        this.set('h', Math.floor((diff % 86400) / 3600));
        this.set('m', Math.floor((diff % 3600) / 60));
        this.set('s', diff % 60);
        this.classList.toggle('cyber-countdown--sin-dias', days === 0);

        if (diff > 0) return;

        window.clearInterval(this.timer);
        this.classList.add('is-ended');
        const ended = this.querySelector('.cyber-countdown__ended');
        if (ended) ended.hidden = false;

        // En el editor de temas nunca se oculta nada, para poder seguir editando.
        if (this.dataset.hideOnEnd === 'true' && !window.Shopify?.designMode) {
          const host = this.closest('[data-cyber-hide-on-end]');
          (host || this).hidden = true;
        }
      }
    }

    customElements.define('cyber-countdown', CyberCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
